import { openChatPane, type OpenChatPaneOptions } from 'owa-copilot-dab/lib/utils/openChatPane';
import { openAgentChatPane } from 'owa-copilot-dab/lib/utils/openAgentChatPane';
import type { AgentType, OpenBizChatSidePaneParams } from 'owa-bizchat-types';
import { isNonExecutableCmmId } from './isNonExecutableCmmId';

/**
 * Specific variation of `openChatPane` that always executes the prompt.
 */
export const executePrompt = (
    promptText: OpenChatPaneOptions['promptText'],
    // Also known as "CMM ID"
    formCode: OpenBizChatSidePaneParams['formCode'],
    targetWindow: Window,
    agentType?: AgentType
): void => {
    const shouldExecuteQuery = !isNonExecutableCmmId(formCode);

    if (agentType) {
        openAgentChatPane({
            promptText,
            targetWindow,
            agentType,
            shouldExecuteQuery,
            formCode,
        });
        return;
    }

    openChatPane({
        params: {
            formCode,
            shouldExecuteQuery,
        },
        promptText,
        targetWindow,
    });
};
